import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Login from './components/Login';
import ItemList from './components/ItemList';
import ResetPassword from './components/ResetPassword';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

function App() {
  return (
        <Switch>
          <Route path="/" exact>
            <Login/>
          </Route>
          <Route path="/ItemList">
            <ItemList/>
          </Route>
          <Route path="/ResetPassword">
            <ResetPassword/>
          </Route>
        </Switch>
  );
}

export default App;
